import { IWebflowEnterprise } from "@wingspanhq/cms/dist/lib/interfaces";

export const selectorEnterpriseName = (enterprise: IWebflowEnterprise) =>
  enterprise.name;
